import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import PageNavigationButtons from './PageNavigationButtons';
import { RelatedLinks } from '@/components/seo/RelatedLinks';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      {/* Auto-renders 3–5 thematically related internal links on every main
          section (returns null for admin, legal, blog-post and unknown routes). */}
      <RelatedLinks />
      <Footer />
      <PageNavigationButtons />
    </div>
  );
}
